import { render, staticRenderFns } from "./CambioStatus.vue?vue&type=template&id=d58887fa&"
import script from "./CambioStatus.vue?vue&type=script&lang=js&"
export * from "./CambioStatus.vue?vue&type=script&lang=js&"
import style0 from "./CambioStatus.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports